/**
 * @generated SignedSource<<e392d3adf7d331adc9c83b8f55b6ba38>>
 * @relayHash 5099f0db419d6d00b89f5c1d31634a2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 494d05e73b3cc631e6cad9e45f64ccd1f6272ecfd097dd67793d672c924d6e60

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { viewSettingsDataResolverQuery } from './viewSettingsDataResolverQuery.graphql';

const node: PreloadableConcreteRequest<viewSettingsDataResolverQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "494d05e73b3cc631e6cad9e45f64ccd1f6272ecfd097dd67793d672c924d6e60",
    "metadata": {},
    "name": "viewSettingsDataResolverQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
